import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Member } from '@models/myoffice/member/member.model'
import { environment } from "@enviroments/environment";
import { ResultProc } from "@app/models/system/result-proc.model";

@Injectable({
    providedIn: 'root'
})
export class HoldingTankService{
    constructor(private _http: HttpClient) { }
    
    listMemberNullPid(params: any){
        let url = `${environment.apiUrl}/member/listMemberNullPid`;

        return this._http.post<Member[]>(url, params);
    };

    countMemberNullPid(params: any){
        let url = `${environment.apiUrl}/member/countMemberNullPid`;

        return this._http.post<Number>(url, params);
    }

    savePid(params: any){
        let url = `${environment.apiUrl}/member/savePid`;

        return this._http.post<ResultProc>(url, params);
    }

}